"use strict";

function DirectUpload() {
  var directUploadPost = null;

  // https://2ndnature.atlassian.net/l/c/odW5KMNG
  async function uploadFile(
    file,
    {
      stringKey = null, // Null to use real file name, string to generate unique name
      progressCallback = undefined,
    } = {},
  ) {
    assertFile(file);
    file = await fixIosBug(file);

    directUploadPost = FormSettings.getDirectUploadPost();

    if (!enabled()) {
      throw new Error(`AWS S3 is not enabled in the API. Please check enabled() before calling.`);
    }

    try {
      return await postFile(file, stringKey, progressCallback);
    } catch (error) {
      if (error instanceof NetworkError && error.status >= 400 && error.status < 500) {
        await getNewPost();
        return await postFile(file, stringKey, progressCallback);
      }

      throw error;
    }
  }

  // iOS 26.5.2 serializes an IndexedDB-backed Blob to an empty request body
  async function fixIosBug(file) {
    const buffer = await file.arrayBuffer();
    return new File([buffer], file.name, { type: file.type });
  }

  function assertFile(file) {
    if (!(file instanceof File)) {
      throw new Error(`${file} must be an instance of the File class.`);
    }
  }

  async function getNewPost() {
    await FormSettings.load();
    directUploadPost = FormSettings.getDirectUploadPost();
  }

  async function postFile(file, stringKey, progressCallback) {
    const fileName = getUniqueFileName(file, stringKey);

    await Retryer.tryPromise(
      () => Network.postTo(directUploadPost.url, getPostData(file, fileName), progressCallback),
      { safeToRetryFunction: Retryer.isSafeToRetryApi },
    );

    return fileName;
  }

  function getUniqueFileName(file, stringKey) {
    if (stringKey === null) {
      return file.name;
    }

    const dotToEndOfString = /\.[^\.]+$/;
    const dotFileExtension = file.name.match(dotToEndOfString)[0];
    const newFileName = `${stringKey}_${UUID.v4()}`;

    return newFileName + dotFileExtension;
  }

  function getPostData(file, fileName) {
    const postData = directUploadPost["otherFields"];
    const path = directUploadPost["fileNameValuePrefix"] + fileName;

    postData[directUploadPost["fileNameFieldName"]] = path;
    postData[directUploadPost["fileFieldName"]] = file;

    return postData;
  }

  function enabled() {
    return directUploadPost !== null || FormSettings.getDirectUploadPost() !== null;
  }

  return {
    uploadFile,
    enabled,
  };
}

module.exports = DirectUpload();

const Network = require("../network");
const FormSettings = require("../settings/formSettings");
const Retryer = require("../general/retryer");
const UUID = require("uuid");
const NetworkError = require("../errors/networkError");
